(() => {
  if (window.__nnMobileCollectionCtaLoaded) return;
  window.__nnMobileCollectionCtaLoaded = true;

  const mobile = window.matchMedia('(max-width: 749px)');
  const hero = document.querySelector('[id$="__hero_jVaWmY"]');
  const original = hero?.querySelector('a[href*="/collections/the-compas-collection"]');

  if (!hero || !original) return;

  const originalHref = original.getAttribute('href');
  const bar = document.createElement('a');
  bar.className = 'nn-mobile-collection-cta';
  bar.href = '#nn-compass-cards';
  bar.setAttribute('aria-label', 'Explore the Compass Collection');
  bar.innerHTML = `
    <span>Explore the Collection</span>
    <svg aria-hidden="true" viewBox="0 0 32 14">
      <path d="M1 7h28M23 1l6 6-6 6"></path>
    </svg>
  `;
  document.body.appendChild(bar);

  let scheduled = false;

  const overlayOpen = () =>
    document.documentElement.hasAttribute('scroll-lock') ||
    Boolean(document.querySelector('dialog[open], .menu-drawer[open]'));

  const update = () => {
    scheduled = false;
    original.setAttribute('href', mobile.matches ? '#nn-shop-routes' : originalHref);

    if (!mobile.matches || overlayOpen()) {
      bar.classList.remove('is-visible');
      return;
    }

    const header = document.querySelector('#header-group');
    const headerEdge = Math.max(0, Math.round(header?.getBoundingClientRect().bottom || 0));
    const originalRect = original.getBoundingClientRect();
    const afterHeroAction = originalRect.bottom <= headerEdge;

    bar.classList.toggle('is-visible', afterHeroAction);
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(update);
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  mobile.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('click', () => window.setTimeout(schedule, 0));

  const observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['scroll-lock', 'class']
  });
  observer.observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ['open', 'hidden', 'aria-hidden']
  });

  schedule();
})();
